module.exports = __webpack_public_path__ + "static/media/banner1.7475728d.jpg";